import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a7aa3cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cell-box xag-container" }
const _hoisted_2 = { class: "cell auto-height" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "describe-header title" }, "设备检测情况说明", -1))
const _hoisted_4 = {
  key: 0,
  class: "describe",
  style: {"margin-top":"4px"}
}
const _hoisted_5 = { class: "cell auto-height" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "describe-header title" }, "设备情况附图", -1))
const _hoisted_7 = {
  key: 0,
  class: "xag-flex images-box"
}
const _hoisted_8 = ["onClick", "src"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "xag-page__footer" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_header = _resolveComponent("app-header")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_app_header, { title: "检测情况" }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        (_ctx.describe)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.describe), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        (_ctx.images.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (image, i) => {
                return (_openBlock(), _createElementBlock("img", {
                  key: i,
                  onClick: ($event: any) => (_ctx.getBigImages(i)),
                  src: image,
                  alt: ""
                }, null, 8, _hoisted_8))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _hoisted_9
  ], 64))
}